<template>
    <v-card-text class="usage">
        <v-layout row wrap>
            <v-flex xs12 class="icon-row first-icon-row">
                <v-layout fill-height row wrap justify-start align-end>
                    <v-img v-if="bay.use.includes('SHARING')" width="50"
                           transition="false" class="shrink ma-2" contain
                           :src="iconSharing"></v-img>
                    <v-img v-if="bay.use.includes('PRIVATE')" width="50"
                           transition="false" class="shrink ma-2" contain
                           :src="iconPrivate"></v-img>
                    <v-img v-if="bay.use.includes('CAR')" width="50"
                           transition="false" class="shrink ma-2" contain
                           :src="iconCar"></v-img>
                    <v-img v-if="bay.charger" width="17" transition="false"
                           class="shrink ma-2" contain
                           :src="iconCharge"></v-img>
                    <v-img v-if="existsIconBayType" width="35"
                           transition="false" contain
                           class="shrink ma-2"
                           :src="urlIconBayType"></v-img>
                </v-layout>
            </v-flex>

            <v-flex v-if="bay.vehicle" xs12 class="icon-row  third-icon-row">
                <v-layout fill-height row wrap justify-start align-end>
                    <v-img v-if="bay.vehicle.batteryState ==='CHARGED'"
                           width="15" transition="false" class="shrink ma-2"
                           contain :src="iconFullCharge"></v-img>
                    <v-img v-if="bay.vehicle.batteryState ==='NDF'" width="15"
                           transition="false" class="shrink ma-2" contain
                           :src="iconNdf"></v-img>
                    <v-img v-if="bay.vehicle.batteryState ==='OUT_OF_SERVICE'"
                           width="15" transition="false" class="shrink ma-2"
                           contain :src="iconOutOfService"></v-img>
                    <v-img v-if="bay.vehicle.batteryState ==='CHARGING'"
                           width="15" transition="false" class="shrink ma-2"
                           contain :src="iconCharging"></v-img>
                    <v-img v-if="bay.vehicle.batteryState ==='NOT_ELETTRIC'"
                           width="15" transition="false" class="shrink ma-2"
                           contain :src="iconNotEletric"></v-img>
                    <v-flex class="label-vehicle"><strong>{{bay.vehicle.code}}</strong> ({{bay.vehicle.vehicleType.name}})</v-flex>
                </v-layout>
            </v-flex>
        </v-layout>
    </v-card-text>
</template>
<script>
    export default {
        name: 'bay-usage',
        data() {
            return {
                existsIconBayType: false
            }
        },
        props: {
            bay: {type: Object},
            urlIconBayType: {
                type: String
            },
            iconCar: {},
            iconCharge: {},
            iconCharging: {},
            iconFaultError: {},
            iconFullCharge: {},
            iconNotEletric: {},
            iconOutOfService: {},
            iconPrivate: {},
            iconSharing: {},
            iconNdf: {}
        },
        methods: {
            async tryFetchIconBayType() {
                const img = await fetch(this.urlIconBayType)
                return img.ok
            }
        },
        created() {
            this.tryFetchIconBayType().then((result) => {
                if (result) {
                    this.existsIconBayType = true
                } else {
                    this.existsIconBayType = false
                }
            })
        },
    }
</script>

<style scoped lang="scss">
    .usage {
        padding-top:0px;

        .label-vehicle {
            text-align: left;
            line-height: 40px;
        }
    }

</style>
